import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, of } from "rxjs";
import { environment } from "../../../../environments/environment";
import { CartResponse } from "src/app/core/cart/dto/response/cart-response.interface";
import { CartRequest } from "src/app/core/cart/dto/request/cart-request.interface";

@Injectable({
  providedIn: "root"})
export class CartService {
  constructor(private _httpClient: HttpClient) {}

  getCartByUserId(userId: string): Observable<CartResponse> {
    return this._httpClient
      .get<CartResponse>(`${environment.backend}/carts?userId=${userId}`)
      .pipe(
        catchError((error) => {
          if (error.status === 404) {
            return of({ id: null, products: [] } as any);
          }
          throw error;
        })
      );
  }

  createCart(request: CartRequest): Observable<CartResponse> {
    return this._httpClient.post<CartResponse>(
      `${environment.backend}/carts`,
      request
    );
  }

  updateCart(cartId: string, request: CartRequest): Observable<CartResponse> {
    return this._httpClient.patch<CartResponse>(
      `${environment.backend}/carts/${cartId}`,
      request
    );
  }

  deleteCart(cartId: string): Observable<void> {
    return this._httpClient.delete<void>(
      `${environment.backend}/carts/${cartId}`
    );
  }
}
